import styled from 'styled-components'
import { Modal } from '@design-systems/canvas-ui'

export const StyledWhatsNewModal = styled(Modal)`
  z-index: 9999;
  [class*='scrollContainer'] {
    overflow-y: hidden;
  }

  .whats-new-media {
    max-width: 100%;
    max-height: 450px;
    object-fit: contain;
    border-radius: 24px;
  }

  .whats-new-media-hidden {
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
  }

  .global-whats-new-description {
    width: 80%;
  }
`
